import axios from 'axios';
import moment from 'moment';

class XmlService {

    async downloadPDF(data) {
        return await axios.post(`${process.env.REACT_APP_API_HOST}/xml/downloadPDF`, data, {
            responseType: 'blob',
        }).catch(function (error) {
            console.log(error);
        })
    }

    async downloadXML(data) {
        return await axios.post(`${process.env.REACT_APP_API_HOST}/xml/downloadXML`, data, {
            responseType: 'blob',
        }).catch(function (error) {
            console.log(error);
        })
    }

    async getTypeXmls(TypeId) {
        return await axios.post(`${process.env.REACT_APP_API_HOST}/document/getTypeXmls`, {
            codigo: TypeId,
        })
    }

    async getDocuments(xmlId) {
        return await axios.get(
            //process.env.REACT_APP_DOTNET_API_HOST + `/api/Employee/GetEmployeeByXmlId/${xmlId}`,
            process.env.REACT_APP_API_HOST + "/document/getid", {
            params: {
                id: xmlId,
            },
            headers: { "content-type": "application/x-www-form-urlencoded" }
        }
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmlsFirmado(DocumentId) {
        return await axios.get(
            process.env.REACT_APP_API_HOST + `/xml/GetXmlsFirmado/` + DocumentId
        ).then((response) => {
            return response.data;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmlsCount(DocumentId) {
        var data = {
            DocumentId: DocumentId
        }
        return await axios.post(
            process.env.REACT_APP_API_HOST + '/xml/GetXmlsCount', data
        ).then((response) => {
            return response.data;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmls(DocumentId) {
        var data = {
            DocumentId: DocumentId
        }
        return await axios.post(
            process.env.REACT_APP_API_HOST + '/xml/GetXmls/', data
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmlsHeader(DocumentId) {
        return await axios.get(
            process.env.REACT_APP_API_HOST + `/document/header?id=${DocumentId}`,
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmlsForEmployee(filter, EmployeeEmail) {

        let query = []

        query.push(`email=${EmployeeEmail}`)

        if (filter.start_date) {
            query.push(`date_from=${moment(filter.start_date).format('YYYY-MM-DD')}`)
        }
        if (filter.end_date) {
            query.push(`date_to=${moment(filter.end_date).format('YYYY-MM-DD')}`)
        }

        if (filter.status === 'T') {
            filter.status = 'ALL';
            query.push(`status=${filter.status}`)
        } else {
            query.push(`status=${filter.status}`)
        }
        //console.log(EmployeeEmail);
        return axios.get(
            //process.env.REACT_APP_DOTNET_API_HOST + `/api/xml/GetXmlsForEmployee/${DocumentId}/${EmployeeEmail}`,
            process.env.REACT_APP_API_HOST + `/document/GetXmlsForEmployee` + (
                query.length > 0 ? `?${query.join('&')}` : ''
            ),
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async statusXmlById(data) {
        return await axios.post(
            process.env.REACT_APP_API_HOST + `/xml/statusXmlById/`, data
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmlById(id) {
        return await axios.get(
            process.env.REACT_APP_API_HOST + `/xml/GetXmlById/` + id
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getXmlDetails(id) {
        return await axios.get(
            process.env.REACT_APP_API_HOST + `/xml/GetXmlDetails/` + id
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async deactivateDocument(id, motivo) {
        return await axios.post(`${process.env.REACT_APP_API_HOST}/signature/${id}/deactivate`, {
            motivo_desactivacion: motivo,
        })
    }

    async getRejections(id) {
        return await axios.get(`${process.env.REACT_APP_API_HOST}/xml/rejections/${id}`)
    }

    async addRejection(data) {
        return axios.post(`${process.env.REACT_APP_API_HOST}/xml/rejections`, data)
    }
}

const instance = new XmlService();

export default instance;